import React from "react";

import { Link } from "react-router-dom";

import Table from "../../common/Table";
import RowPhoto from "../../common/TdImg";

const StudentListTable = ({ data }) => {
  const renderLink = (e) => {
    return (
      <Link
        to={`/mis/students/${e.student_id}/profile/fees?stdName=${e.full_name}`}
      >
        {e.full_name}
      </Link>
    );
  };

  const columns = [
    { path: "id", label: "شماره" },
    {
      path: "student_photo",
      label: "عکس",
      content: ({ student_photo }) => <RowPhoto src={student_photo} />,
    },
    { path: "aria_id", label: "کد دانشجو" },
    {
      path: "full_name",
      label: "اسم",
      content: (e) => renderLink(e),
    },
    { path: "student_father_name", label: "ولد" },
    { path: "fee", label: "فیس" },
    { path: "discount", label: "تخفیف" },
    { path: "paid", label: "پرداخت شده" },
    { path: "payable", label: "باقی‌مانده" },
    { path: "current_overall_balance", label: "مجموعه باقی" },
    { path: "option" },
  ];

  return <Table data={data} columns={columns} />;
};

export default StudentListTable;
